import * as React from 'react';

import { Block, Col, Row } from 'emotion-jsxstyle';
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { PageDropdownItem } from './PageDropdownItem';

import { ActionButton } from './ActionButton';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { MQ } from '../../Theme';
import { History } from 'history';
import Media from 'react-media';

export interface PageAction {
  /** Control logic if the action should be rendered or not */
  shouldRender?: boolean;
  /** External link */
  href?: string;
  /** External link: stay in same tab (default false) */
  hrefSameTab?: boolean;
  /** Internal react-router link */
  to?: string;
  /** Action click handler */
  onClick?: () => void;
  /** Action label */
  label: string;
  /** Font awesome icon name */
  iconName?: string;
  /** Test ID */
  testId?: string;
}

interface PageProps {
  /** Page title */
  title: string;
  /** List of breadcrumbs */
  breadcrumbs?: {
    /** Breadcrumb label */
    label: string;
    /** Pathname */
    to: string;
  }[];
  /** Inner JSX of the page. */
  children?: any;
  /** Primary page action. This will appear as a primary button on the top right. */
  primaryAction?: PageAction;
  /** List of secondary page actions. */
  secondaryActions?: PageAction[];
  /** History, for clicking mobile links */
  history?: History;
  /** Test ID */
  testId?: string;
}

export class Page extends React.Component<PageProps> {
  render() {
    const props = this.props;
    return (
      <div className="p-0 p-md-2 p-lg-4" data-testid={props.testId}>
        <Row justifContent="space-between" alignItems="center" className="p-3 px-md-0 pt-md-0 pb-md-3">
          <Col flex="1">
            {props.breadcrumbs &&
              props.breadcrumbs.map((b, i) => (
                <Link className="text-muted" to={b.to} key={'breadcrumb--' + i}>
                  <i className="fa fa-chevron-left" /> {b.label}
                </Link>
              ))}
            <h1 className="h3 d-block my-3 font-weight-bold">{props.title}</h1>
            <Helmet titleTemplate="%s | NKBA Admin">
              <title>{props.title}</title>
            </Helmet>

            <Media query={MQ.LG}>
              {(match: boolean) =>
                !!match ? (
                  <Row justifContent="space-between" alignItems="center" flex="1">
                    {props.secondaryActions &&
                      props.secondaryActions.length > 0 &&
                      props.secondaryActions.map(
                        ({ shouldRender, href, hrefSameTab, to, label, iconName, onClick, testId }, i) =>
                          shouldRender && (
                            <Block marginRight="1rem" key={label}>
                              <ActionButton
                                href={href}
                                sameTab={hrefSameTab}
                                to={to}
                                label={label}
                                iconName={iconName}
                                onClick={onClick}
                                data-testid={testId}
                              />
                            </Block>
                          )
                      )}
                  </Row>
                ) : (
                  <Row justifyContent="space-between" alignItems="center">
                    {props.secondaryActions && (
                      <UncontrolledDropdown>
                        <DropdownToggle caret={true}>Actions</DropdownToggle>
                        <DropdownMenu>
                          {props.secondaryActions.map(
                            (action, i) =>
                              action.shouldRender && (
                                <PageDropdownItem action={action} key={action.label} history={this.props.history} />
                              )
                          )}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    )}
                    {props.primaryAction &&
                      props.primaryAction.shouldRender && (
                        <Block>
                          <ActionButton
                            label={props.primaryAction.label}
                            href={props.primaryAction.href}
                            sameTab={props.primaryAction.hrefSameTab}
                            to={props.primaryAction.to}
                            onClick={props.primaryAction.onClick}
                            iconName={props.primaryAction.iconName}
                            primary={true}
                            data-testid="pageActionPrimary"
                          />
                        </Block>
                      )}
                  </Row>
                )
              }
            </Media>
          </Col>
          <Media query={MQ.LG}>
            {props.primaryAction &&
              props.primaryAction.shouldRender && (
                <Block>
                  <ActionButton
                    label={props.primaryAction.label}
                    href={props.primaryAction.href}
                    sameTab={props.primaryAction.hrefSameTab}
                    to={props.primaryAction.to}
                    onClick={props.primaryAction.onClick}
                    iconName={props.primaryAction.iconName}
                    primary={true}
                    data-testid="pageActionPrimary"
                  />
                </Block>
              )}
          </Media>
        </Row>
        <Block>{props.children}</Block>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/layout/Page/Page.tsx